document.addEventListener("DOMContentLoaded", function () {
    if ($("#cart-page")) {
        const vm = new Vue({
        el: "#cart-page",
        data: {

            tabs: [
            " Общие сведения",
            "Сведения об организации",
            "Заказчики",
            "Сведения о предмете контракта",
            "Документы"
            ],
            selectedTabId: 0,
        }
        });
    }
})